// apps/web/src/queryClient.ts
import { QueryClient } from '@tanstack/react-query';
import { shouldRetryQuery } from './api/query-retry.js';

/**
 * @aiPurpose application-wide React Query client. Exported as a module
 *   singleton so route loaders (`apps/web/src/router/routes.tsx`) can call
 *   `queryClient.fetchQuery` without going through the React tree.
 * @aiInvariant `staleTime: 30_000` matches the rationale documented at the
 *   call site of every `useQuery` invocation; mutations never retry to
 *   avoid double-charge / double-revoke side effects.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // WHY: transient NetworkError retries up to 2x; ThrottleError (429) and
      // ApiClientError (4xx) never retry — see api/query-retry.ts.
      retry: shouldRetryQuery,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 4000),
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      // WHY: mutations never auto-retry — user must explicitly re-submit to
      // avoid double-charge / double-revoke side effects.
      retry: false,
    },
  },
});
